import { dev } from './devLog';

export type SessionGrant = { expiresAt: number };

let _cache: SessionGrant | null = null;

export function clearSessionTokenCache(): void {
  _cache = null;
}

export function getCachedSessionGrant(): SessionGrant | null {
  if (!_cache) return null;
  // Expire 60s early so the grant is never used at the edge of its validity
  if (_cache.expiresAt < Date.now() + 60_000) {
    dev.log('[session-token] cache expired, clearing');
    _cache = null;
    return null;
  }
  dev.log('[session-token] cache hit, valid until', new Date(_cache.expiresAt).toLocaleTimeString());
  return _cache;
}

export function setCachedSessionGrant(grant: SessionGrant): void {
  _cache = grant;
}
